var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdventage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6972 12.7592H0L19.1388 34.3283L12.5998 14.1428C12.3326 13.3179 11.5643 12.7592 10.6972 12.7592Z",
    fill: "#81168C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0992 12.7592H39.7964L20.6576 34.3283L27.1966 14.1428C27.4638 13.3179 28.2321 12.7592 29.0992 12.7592Z",
    fill: "#81168C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4421 12.7592H16.3937C15.0437 12.7592 14.0815 14.0692 14.4853 15.3574L20.0505 33.1131L25.3585 15.3313C25.7414 14.0486 24.7806 12.7592 23.4421 12.7592Z",
    fill: "#81168C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.2402L5.77201 0.607574L11.544 11.2402H0Z",
    fill: "#81168C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9751 11.2402L19.7471 0.607574L25.5191 11.2402H13.9751Z",
    fill: "#81168C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9487 11.2402L33.7207 0.607574L39.4927 11.2402H27.9487Z",
    fill: "#81168C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8091 -1.23978e-05L27.0371 10.6326L21.2651 -1.3407e-05L32.8091 -1.23978e-05Z",
    fill: "#81168C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2271 -1.23978e-05L12.455 10.6326L6.68304 -1.3407e-05L18.2271 -1.23978e-05Z",
    fill: "#81168C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdventage3);
export default __webpack_public_path__ + "static/media/adventage_3.4378b975e4711e5add3efa295613bd25.svg";
export { ForwardRef as ReactComponent };